<script>
  import { Router, Route } from "svelte-routing";

  // components for this layout
  import AdminNavbar from "components/Navbars/AdminNavbar.svelte";
  import Sidebar from "components/Sidebar/Sidebar.svelte";
  import HeaderStats from "components/Headers/HeaderStats.svelte";
  import FooterAdmin from "components/Footers/FooterAdmin.svelte";

  // pages for this layout
  import Dashboard from "views/admin/Dashboard.svelte";
  import Settings from "views/admin/Settings.svelte";
  import Customer from "views/admin/Customer.svelte";
  import Maps from "views/admin/Maps.svelte";
  import Logout from "views/admin/Logout.svelte";
  import Survey from "views/admin/survey.svelte";

  export let location;
  export let admin = "";
</script>

<div>
  <Sidebar location={location}/>
  <div class="relative md:ml-64 bg-blueGray-100">
    <AdminNavbar />
    <HeaderStats />
    <div class="px-4 md:px-10 mx-auto w-full -m-24">
      <Router url="admin">
        <Route path="dashboard" component="{Dashboard}" />
        <Route path="settings" component="{Settings}" />
        <Route path="customer" component="{Customer}" />
        <Route path="logout" component="{Logout}" />
        <Route path="maps" component="{Maps}" />
        <Route path="survey" component="{Survey}" />
      </Router>
      <FooterAdmin />
    </div>
  </div>
</div>
